var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSession = function SvgSession(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 38,
    height: 38,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentcolor",
    fillRule: "evenodd",
    d: "M23.75 32.415h5.5V22.017l4.07-6.21 2.332 2.771 1.53-1.287-4.061-4.829-3.871 5.906V10.5h7.25v-1h-7.25V5.582h-5.5v1.5h4v2.417h-1.485L21.5 15.22l-2.52-3.025-4.508 6.01-2.637-3.043V7.083h4v-1.5h-5.5v7.847l-2.295-2.648-6.879 6.35.678.735 6.121-5.65 2.375 2.74v6.023L7.926 18.51 4.117 22.32l-1.826-1.826-1.414 1.414 3.24 3.24 3.791-3.79 2.426 2.486v8.573h5.5v-1.5h-4v-5.535l4.708 4.827 5.075-6.344 3.88 3.88 2.253-3.44v6.61h-4zm4-11.758-2.578 3.934-3.72-3.72-5.059 6.322-4.559-4.675v-5.83l2.693 3.107 4.493-5.99 2.48 2.975 5.233-6.28h1.017z",
    clipRule: "evenodd"
  })));
};
export default SvgSession;